// @dynamic
var DiagramConsts = /** @class */ (function () {
    function DiagramConsts() {
    }
    DiagramConsts.elements = {
        imageKey: 'Image',
        numericalDisplayKey: 'NumericalDisplay',
        textKey: 'Text',
        hyperlinkKey: 'Hyperlink',
        meterKey: 'Meter',
        pipeKey: 'Pipe',
        switchIndicatorLightKey: 'SwitchIndicatorLight',
        barGraphKey: 'BarGraph',
        toggleViewKey: 'ToggleView',
        characterKey: 'Character',
        straightLineKey: 'StraightLine',
        polyLineKey: 'PolyLine',
        rectangleKey: 'Rectangle',
        ellipseKey: 'Ellipse',
        sectorKey: 'Sector',
        dateTimeKey: 'DatetimeDisplay',
        historyCurveKey: 'HistoricalCurve',
        ringGraphKey: 'RingGraph',
        polygonKey: 'Polygon',
        tableKey: 'Table',
        videoKey: 'Video',
        weatherKey: 'Weather'
    };
    return DiagramConsts;
}());
export { DiagramConsts };
